var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"flat":"","outlined":"","elevate-on-scroll":"","app":""}},[_c('img',{staticClass:"nav-logo",attrs:{"src":_vm.logoImage,"alt":"Optoro Logo"}}),_c('v-toolbar-title',[_vm._v("Optiturn")]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }